import { useMutation } from "react-query";
import http from "infra/http";

function useConcluirManutencao(manutencaoId: string, realizacaoId: string) {
  return useMutation(
    () => {
      return http.post(
        `/v1/manutencao/${manutencaoId}/realizacao/${realizacaoId}`
      );
    },
    { retry: false }
  );
}

export default useConcluirManutencao;
